import React from 'react'
import { Link } from 'react-router-dom'
import TitleContentSection from '../titlecontentsection/TitleContentSection'
import './Localizacion.css'
import BaseComponent from '../basecomponent/BaseComponent'

const MyMapComponent = () => (
    <div className="Localizacion-Map-Wrapper">
        <iframe
            frameBorder="0"
            title="Google Maps"
            src="https://maps.google.es/maps?f=q&amp;source=s_q&amp;hl=es&amp;geocode=&amp;q=Clinica+Dental+Balmes,+Igualada&amp;aq=0&amp;oq=clinica+dental+balmes&amp;sll=41.692248,1.745868&amp;sspn=2.227191,5.410767&amp;ie=UTF8&amp;hq=Clinica+Dental+Balmes,&amp;hnear=Igualada,+Barcelona,+Catalu%C3%B1a&amp;t=m&amp;ll=41.587298,1.614175&amp;spn=0.007704,0.013733&amp;z=16&amp;iwloc=A&amp;output=embed">
            </iframe>
    </div>
)

const LocalizacionComponent = () => (
    <div className="Localizacion">
        <TitleContentSection title="¡Encuéntrenos! Estaremos encantados de atenderle">
            <h3 className="Section-Content">Estamos ubicados en Avenida Balmes 61-69, primer piso, en Igualada, Barcelona. En el apartado de <Link className="link" to='/contacto'>Contacto</Link> podrá ver nuestro horario de atención al público</h3>
        </TitleContentSection>
        
        <MyMapComponent />
        
    </div>
)

const Localizacion = BaseComponent(LocalizacionComponent, "Localizacion")

export default Localizacion



// WEBPACK FOOTER //
// ./src/components/localizacion/Localizacion.js